import React from "react";

const VanityLinks = () => {
  return (


    <div style={{ display: "inline" }}>
      
      
      <a href="https://englishonline.sjv.io/xkngqk">
        <img
          alt=""
          src="https://th.bing.com/th/id/OIP.BDBAGYQosnrWp-8EmWwc5AHaEK?pid=ImgDet&w=590&h=332&rs=1"
          height="60px"
          width="130px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://getabstract.sjv.io/Kjq3b7">
        <img
          alt=""
          src="https://www.getabstract.com/www/images/logos/2022/ga-logo-cb-p93skzn4qqt8blja2pl7ts4bbondig.svg"
          height="60px"
          width="160px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://ioa.pxf.io/5gkNnN">
        <img
          alt=""
          src="https://cdn.shopify.com/s/files/1/0507/8738/5531/files/2020_-_IOA_Logo_-_Colour_Black_600x.png?v=1636364746"
          height="60px"
          width="130px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=145238.10000683&bids=145238.10000683&type=3&subid=0">
        <img
          alt=""
          src="https://cdn.cookielaw.org/logos/0d555ebd-3f0a-478d-9caa-67540b18e205/634908ed-89cf-4ff8-bb47-6ea05463d200/e6e58ecd-f236-4540-a116-2411aca23369/PearsonLogo_Horizontal_Blk_RGB.png"
          height="60px"
          width="140px"
          style={{
            margin: "20px",
            borderRadius: "20px",
          }}
        />
      </a>

      <a href="https://switch-research.sjv.io/nLnmjM">
        <img
          alt=""
          src="https://cdn.shopify.com/s/files/1/0404/4043/0749/files/switch-l_120x.png?v=1653008649"
          height="40px"
          width="120px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://imp.i115008.net/Pya1LR">
        <img
          alt=""
          src="https://www.udacity.com/images/svgs/udacity-tt-logo.svg"
          height="60px"
          width="130px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=1074652.3&bids=1074652.3&subid=0&type=4">
        <img
          alt=""
          src="https://www.udemy.com/staticx/udemy/images/v7/logo-udemy.svg"
          height="60px"
          width="110px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href=" https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=871625.3&bids=871625.3&subid=0&type=4">
        <img
          alt=""
          src="https://assets.futurelearn.com/packs/app/assets/images/fl_logo-f9d7f37a61915a2fbf8a.svg"
          height="60px"
          width="120px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=915143.5&bids=915143.5&type=3&subid=0">
        <img
          alt=""
          src="https://edu360.wpengine.com/wp-content/uploads/logo.png"
          height="60px"
          width="140px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=1079430.3&bids=1079430.3&type=3&subid=0">
        <img
          alt=""
          src="https://www.learnworlds.com/app/themes/learnworlds/dist/images/logo.svg"
          height="60px"
          width="162px"
          style={{ margin: "20px", borderRadius: "20px" }}
        />
      </a>
      <a href="https://memrise.pxf.io/anNdoY">
        <img
          alt=""
          src="https://6968579.fs1.hubspotusercontent-na1.net/hubfs/6968579/Memrise%20July%202020/Images/logo_yellow.svg"
          height="45px"
          width="50px"
          style={{
            margin: "20px",
          }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=1234368.2&bids=1234368.2&type=3&subid=0">
        <img
          alt=""
          src="https://quizplus.com/assets/images/main/svgs/main-logo.svg"
          height="60px"
          width="160px"
          style={{
            margin: "20px",
            borderRadius: "20px",
            backgroundColor: "blue",
          }}
        />
      </a>
      <a href="pocketprep.sjv.io/q4Wvx5">
        <img
          alt=""
          src="https://www.pocketprep.com/wp-content/uploads/2021/07/Pocket-Prep-Logo.png"
          height="60px"
          width="140px"
          style={{
            margin: "20px",
            borderRadius: "20px",
          }}
        />
      </a>
      <a href="https://click.linksynergy.com/fs-bin/click?id=jtjDTYhAZDg&offerid=1234368.2&bids=1234368.2&type=3&subid=0">
        <img
          alt=""
          src="https://mproxy.banner.linksynergy.com/fs/banners/49431/49431_5.png"
          height="60px"
          width="150px"
          style={{
            margin: "20px",
            borderRadius: "20px",
          }}
        />
      </a>
    </div>
  );
};

export default VanityLinks;
